// dependencies
import { List } from "immutable";

// selectors
import { getUI } from "Selectors/ui";
import { getPageQueryValue } from "Selectors/app";

export const getLimit = (state) => getPageQueryValue(state, "limit");
export const getOffest = (state) => getPageQueryValue(state, "offset");
export const getData = (state) => getUI(state).get("data", List());
export const getCSVData = (state) => getUI(state).get("csvData", "");
